import { isRight } from 'fp-ts/lib/Either';
import { ThunkResult } from '../../../redux/configureStore';
import { UserDataGateway } from '../../gateways/userDataGateway.interface';
import * as actionCreators from './actionCreators';
import { OfficeCountry, OfficeLanguage } from '../../config/appConfig';

export const getBannerUseCase =
    (language: OfficeLanguage, country: OfficeCountry): ThunkResult<void> =>
    async (dispatch, getState, { userDataGateway }: { userDataGateway: UserDataGateway }) => {
        dispatch(actionCreators.Actions.bannerFetching());

        const result = await userDataGateway.getBanner(language, country);

        if (isRight(result)) {
            dispatch(actionCreators.Actions.bannerRetrieved(result.right));
        } else {
            dispatch(actionCreators.Actions.bannerFailed());
        }
    };
